var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"modal",staticStyle:{"z-index":"999999 !important"},attrs:{"state":_vm.isModalOpen ? 'open' : 'close'}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }